import { createFeatureSelector, createSelector } from '@ngrx/store';
import { isEmpty } from 'ramda';
import {
  DestinationCountryData,
  SendValidateResponse,
  TransactionState,
} from './types';

const selectState = createFeatureSelector<TransactionState>('transactionState');

export const selectTransactionState = createSelector(
  selectState,
  (state: TransactionState) => state
);

export const selectWalletProvider = createSelector(
  selectState,
  (state: TransactionState) => state?.feeLookupResponse?.additionalInfos
);

export const selectReferenceNumber = createSelector(
  selectState,
  (state: TransactionState) => state?.sendCommitResponse?.referenceNumber
);

export const selectConfirmationCode = createSelector(
  selectState,
  (state: TransactionState) => state?.sendCommitResponse?.confirmationCode
);

export const selectDestinationCountryData = createSelector(
  selectState,
  (state: TransactionState) => state.destinationCountryData!
);

export const selectDestinationCurrency = createSelector(
  selectDestinationCountryData,
  (state: DestinationCountryData): string => state.currency!
);

export const selectDestinationCountry = createSelector(
  selectDestinationCountryData,
  (state: DestinationCountryData): string => state.country!
);

// TOdo: Tim: #may6 - might not need this specific selector if the whole transaction state will be subscribed to in digital-payment.ts
export const selectPaymentMethod = createSelector(
  selectState,
  (state: TransactionState) => state.paymentMethod
)

export const selectFeeLookupResponse = createSelector(
  selectState,
  (state: TransactionState) => state.feeLookupResponse
);

// TODO -- did not see this used anywhere and had a typing error
// export const selectFeeLookupQuote = createSelector(
//   selectFeeLookupResponse,
//   (feeLookupResponse: FeeLookupResponse): Transaction => feeLookupResponse.transactions![0]
// );

export const selectSendValidateResponse = createSelector(
  selectState,
  (state: TransactionState): SendValidateResponse => state.sendValidateResponse!
);

export const selectsendCommitResponse = createSelector(
  selectState,
  (state: TransactionState): any => state.sendCommitResponse!
);

export const transactionStatusResponse = createSelector(
  selectState,
  (state: TransactionState): any => state.transactionStatusResponse
);

export const getRefundResponse = createSelector(
  selectState,
  (state: TransactionState): any => state.getRefundResponse
);

export const confirmRefundResponse = createSelector(
  selectState,
  (state: TransactionState): any => state.confirmRefundResponse
);

export const getSelectedLocationTrns = createSelector(
  selectState,
  (state: any) => state.selectedLocation
);

export const isLocationSelected = createSelector(
  selectState,
  (state: any) => !isEmpty(state.selectedLocation)
);
